import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, XIcon } from 'lucide-react';
import { navItems } from '../data/site';
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  return <header className="sticky top-0 z-40 border-b border-ink/10 bg-cream/90 backdrop-blur" data-id="element-155" data-mp="1ipwh87gmz8dh">
      <div className="mx-auto flex max-w-page items-center justify-between gap-6 px-6 py-4 lg:px-10" data-id="element-156" data-mp="v0bnqumuwspy">
        <Link to="/" className="group flex flex-col leading-none focus:outline-none focus-visible:ring-2 focus-visible:ring-sage-deep focus-visible:ring-offset-2 focus-visible:ring-offset-cream" data-id="element-157" data-mp="qyqhvt8qpep9">
          <span className="font-serif text-lg tracking-tight text-ink" data-id="element-158" data-mp="2gbbskd6tff2q">Christine Velluet</span>
          <span className="mt-1 text-[11px] font-light uppercase tracking-[0.22em] text-sage-deep" data-id="element-159" data-mp="2bcr235hd89rh">
            Pilates · Stretching postural
          </span>
        </Link>

        <nav aria-label="Navigation principale" className="hidden items-center gap-7 lg:flex" data-id="element-160" data-mp="29lwlp3eia1lv">
          {navItems.map(item => <NavLink key={item.to} to={item.to} className={({
          isActive
        }) => `whitespace-nowrap text-sm transition-colors duration-150 ease-soft focus:outline-none focus-visible:ring-2 focus-visible:ring-sage-deep focus-visible:ring-offset-2 focus-visible:ring-offset-cream ${isActive ? 'text-ink' : 'text-ink/60 hover:text-ink'}`} data-id="element-161" data-mp="2jhggtnl8ww9k">
              {item.label}
            </NavLink>)}
          <Link to="/contact" className="whitespace-nowrap rounded-full bg-ink px-5 py-2.5 text-sm text-ivory transition-colors duration-150 ease-soft hover:bg-sage-deep focus:outline-none focus-visible:ring-2 focus-visible:ring-sage-deep focus-visible:ring-offset-2 focus-visible:ring-offset-cream" data-id="element-162" data-mp="25igq8ae6a7ar">
            Réserver un cours
          </Link>
        </nav>

        <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls="menu-mobile" className="inline-flex items-center gap-2 rounded-full border border-ink/15 px-4 py-2 text-sm text-ink transition-colors duration-150 ease-soft hover:border-ink/40 lg:hidden" data-id="element-163" data-mp="102wve36rr1i0">
          {open ? <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-164" data-mp="m46yoonv33u6" /> : <MenuIcon className="h-4 w-4" aria-hidden="true" data-id="element-165" data-mp="h4c86m800g9n" />}
          Menu
        </button>
      </div>

      {open && <nav id="menu-mobile" aria-label="Navigation mobile" className="border-t border-ink/10 bg-cream px-6 pb-6 pt-2 lg:hidden" data-id="element-166" data-mp="w1uvrl8xwnfi">
          <ul className="divide-y divide-ink/10" data-id="element-167" data-mp="27enlkqi671sx">
            {navItems.map(item => <li key={item.to} data-id="element-168" data-mp="22hez4dpzoblv">
                <NavLink to={item.to} className="block py-3 text-base text-ink" data-id="element-169" data-mp="22g40stfbbw25">
                  {item.label}
                </NavLink>
              </li>)}
          </ul>
          <Link to="/contact" className="mt-5 inline-flex rounded-full bg-ink px-5 py-3 text-sm text-ivory" data-id="element-170" data-mp="2f00ukphjldcg">
            Réserver un cours
          </Link>
        </nav>}
    </header>;
}